import { createSelector } from '@reduxjs/toolkit';
import getCatalogGradeByCar from './getCatalogGradeByCar';

const getCarOptions = createSelector(getCatalogGradeByCar, grade => {
  return grade?.options;
});

export default getCarOptions;
